import PropTypes from "prop-types";
import React from "react";
import { Button, Dialog, Dropdown, Input, Text } from "@fluentui/react-northstar";

const filterItems = [
  { key: "all", label: "All Commands" },
  { key: "success", label: "Successful" },
  { key: "failed", label: "Failed" },
  { key: "attendance", label: "Attendance" },
  { key: "navigation", label: "Navigation" },
  { key: "notes", label: "Notes" },
];

const CommandLogModal = ({
  open,
  onOpenChange,
  onClose,
  filteredCommandLog,
  logSearchTerm,
  onSearchChange,
  logFilterType,
  onFilterChange,
  commandLog,
  onClearLog,
  commandLogContentRef,
}) => (
  <Dialog
    open={open}
    onOpenChange={onOpenChange}
    onCancel={onClose}
    header="Voice Command Log"
    backdrop
    closeOnOutsideClick
    content={
      <div className="command-log-modal" ref={commandLogContentRef}>
        <div className="log-controls">
          <div className="search-control">
            <Input
              placeholder="Search commands, students, or types..."
              value={logSearchTerm}
              onChange={(e, data) => onSearchChange(data.value)}
              fluid
            />
          </div>
          <div className="filter-control">
            <Dropdown
              placeholder="Filter by type"
              items={filterItems.map((item) => item.label)}
              value={filterItems.find((item) => item.key === logFilterType)?.label}
              onChange={(e, data) => {
                const selected = filterItems.find((item) => item.label === data.value);
                onFilterChange(selected?.key || "all");
              }}
            />
          </div>
        </div>

        <div className="log-list">
          {filteredCommandLog.length === 0 ? (
            <div className="no-commands">
              <Text content="No commands found" />
            </div>
          ) : (
            filteredCommandLog.map((entry) => (
              <div
                key={entry.id}
                className={`log-entry ${entry.success ? "success" : "failed"}`}
              >
                <div className="entry-header">
                  <div className="entry-status">
                    <div
                      className={`status-indicator ${entry.success ? "success" : "failed"}`}
                    />
                    <Text
                      content={entry.success ? "✓" : "✗"}
                      size="small"
                      className="status-icon"
                    />
                  </div>
                  <div className="entry-time">
                    <Text
                      content={new Date(entry.timestamp).toLocaleString()}
                      size="small"
                      className="timestamp"
                    />
                  </div>
                </div>
                <div className="entry-content">
                  <Text content={entry.command} size="medium" className="command-text" />
                  {entry.studentName && (
                    <Text
                      content={`Student: ${entry.studentName}`}
                      size="small"
                      className="student-name"
                    />
                  )}
                  <Text
                    content={`Type: ${entry.displayType || entry.type}`}
                    size="small"
                    className="command-type"
                  />
                  <Text
                    content={entry.message}
                    size="small"
                    className="result-message"
                  />
                </div>
              </div>
            ))
          )}
        </div>

        <div className="log-actions">
          <Button content="Clear Log" onClick={onClearLog} disabled={commandLog.length === 0} />
          <Button content="Close" primary onClick={onClose} />
        </div>
      </div>
    }
    cancelButton={false}
    confirmButton={false}
    styles={{
      width: "90vw",
      maxWidth: "800px",
      maxHeight: "80vh",
    }}
  />
);

CommandLogModal.propTypes = {
  commandLog: PropTypes.array.isRequired,
  commandLogContentRef: PropTypes.object.isRequired,
  filteredCommandLog: PropTypes.array.isRequired,
  logFilterType: PropTypes.string.isRequired,
  logSearchTerm: PropTypes.string.isRequired,
  onClearLog: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default CommandLogModal;

